/** Mirrors para-node `src/constants/remote-config.constants.ts`. */
export enum RemoteConfigApp {
  Client = 'client',
  Dashboard = 'dashboard',
}

export enum RemoteConfigValueType {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Json = 'json',
}

/** The API's domain error names the modals map (`error` in the body, api-spec.yaml). */
export enum RemoteConfigErrorCode {
  NotFound = 'RemoteConfigNotFoundError',
  KeyAlreadyExists = 'RemoteConfigKeyAlreadyExistsError',
  ValueTypeMismatch = 'RemoteConfigValueTypeMismatchError',
  ValueTooLarge = 'RemoteConfigValueTooLargeError',
  Unknown = 'Unknown',
}

export enum RemoteConfigTableFields {
  key = 'key',
  type = 'type',
  value = 'value',
  description = 'description',
  enabled = 'enabled',
  updatedAt = 'updatedAt',
  actions = 'actions',
}

export const remoteConfigAppTitles: Record<RemoteConfigApp, string> = {
  [RemoteConfigApp.Client]: 'Contractor onboarding',
  [RemoteConfigApp.Dashboard]: 'Customer dashboard',
}

export const remoteConfigValueTypeTitles: Record<RemoteConfigValueType, string> = {
  [RemoteConfigValueType.String]: 'Text',
  [RemoteConfigValueType.Number]: 'Number',
  [RemoteConfigValueType.Boolean]: 'Boolean',
  [RemoteConfigValueType.Json]: 'JSON',
}

export const remoteConfigTableHeaderTitles: Record<RemoteConfigTableFields, string> = {
  [RemoteConfigTableFields.key]: 'Key',
  [RemoteConfigTableFields.type]: 'Type',
  [RemoteConfigTableFields.value]: 'Value',
  [RemoteConfigTableFields.description]: 'Description',
  [RemoteConfigTableFields.enabled]: 'Status',
  [RemoteConfigTableFields.updatedAt]: 'Last change',
  [RemoteConfigTableFields.actions]: '',
}

// The API's limits (para-node remote-config.constants.ts), enforced here so they are never a 400.
export const REMOTE_CONFIG_KEY_PATTERN = /^[a-z0-9_.]+$/
export const REMOTE_CONFIG_KEY_MAX_LENGTH = 100
export const REMOTE_CONFIG_DESCRIPTION_MAX_LENGTH = 500
export const REMOTE_CONFIG_VALUE_MAX_BYTES = 65536

export const REMOTE_CONFIG_NUMBER_MESSAGE = 'Enter a number'
export const REMOTE_CONFIG_JSON_EMPTY_MESSAGE = 'Enter a JSON object or array'
export const REMOTE_CONFIG_JSON_INVALID_MESSAGE = "This isn't valid JSON"
export const REMOTE_CONFIG_JSON_SINGLE_VALUE_MESSAGE =
  'Enter a JSON object or array, not a single value'
export const REMOTE_CONFIG_VALUE_TOO_LARGE_MESSAGE = 'Keep the value under 64 KB'
export const REMOTE_CONFIG_SAVE_FAILED_MESSAGE = "The key wasn't saved. Please try again."
export const REMOTE_CONFIG_DELETE_FAILED_MESSAGE = "The key wasn't deleted. Please try again."
export const REMOTE_CONFIG_GONE_MESSAGE = 'This key no longer exists.'
